// actions/casteActions.js
// BUG FIX: this used a standalone axios instance (cookie-only auth),
// unlike the rest of the app's action files which use createApi() from
// utils/apiClient — that shared client also attaches the JWT as a
// Bearer header from localStorage, which is what makes auth work inside
// Capacitor (mobile) and Electron, where cross-origin cookies are
// unreliable/don't persist. Without it, every call in this file would
// silently 401 on mobile/desktop (web was fine, since cookies work
// there).
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllCastes =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_CASTES_REQUEST" });
      const { data } = await api.get("/castes", { params });
      dispatch({ type: "ALL_CASTES_SUCCESS", payload: data.castes });
    } catch (err) {
      dispatch({
        type: "ALL_CASTES_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

// Admin "Pending Approval" tab
export const getPendingCastes = () => async (dispatch) => {
  try {
    dispatch({ type: "PENDING_CASTES_REQUEST" });
    const { data } = await api.get("/castes/pending");
    dispatch({
      type: "PENDING_CASTES_SUCCESS",
      payload: data.castes,
    });
  } catch (err) {
    dispatch({
      type: "PENDING_CASTES_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const createCaste = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_CASTE_REQUEST" });
    const { data } = await api.post("/castes", payload);
    dispatch({ type: "CREATE_CASTE_SUCCESS", payload: data.caste });
    return data;
  } catch (err) {
    dispatch({
      type: "CREATE_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Called from the Add Staff form's "+ type a new value" option.
// Saves as "pending" — does NOT show up in dropdowns until approved.
export const suggestCaste = (name, parent_id) => async (dispatch) => {
  try {
    dispatch({ type: "SUGGEST_CASTE_REQUEST" });
    const { data } = await api.post("/castes/suggest", { name, parent_id });
    dispatch({ type: "SUGGEST_CASTE_SUCCESS", payload: data.caste });
    return data;
  } catch (err) {
    dispatch({
      type: "SUGGEST_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const approveCaste = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/castes/${id}/approve`);
    dispatch({ type: "APPROVE_CASTE_SUCCESS", payload: data.caste });
    return data;
  } catch (err) {
    dispatch({
      type: "APPROVE_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const rejectCaste = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.put(`/castes/${id}/reject`, { reason });
    dispatch({ type: "REJECT_CASTE_SUCCESS", payload: data.caste });
    return data;
  } catch (err) {
    dispatch({
      type: "REJECT_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const updateCaste = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_CASTE_REQUEST" });
    const { data } = await api.put(`/castes/${id}`, payload);
    dispatch({ type: "UPDATE_CASTE_SUCCESS", payload: data.caste });
    return data;
  } catch (err) {
    dispatch({
      type: "UPDATE_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const deleteCaste = (id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_CASTE_REQUEST" });
    const { data } = await api.delete(`/castes/${id}`);
    dispatch({ type: "DELETE_CASTE_SUCCESS", payload: id });
    return data;
  } catch (err) {
    dispatch({
      type: "DELETE_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// A rejected entry can be resubmitted — resets it back to "pending" so it
// shows up in the Approvals queue again.
export const resubmitCaste = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/castes/${id}/resubmit`);
    dispatch({ type: "RESUBMIT_CASTE_SUCCESS", payload: data.caste });
    return data;
  } catch (err) {
    dispatch({
      type: "RESUBMIT_CASTE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Rejected list — shown on the Approvals page so admin/requester can
// review the reason and Resubmit if needed. Stored separately from the
// active dropdown list (state.caste.rejected) to avoid clobbering it.
export const getRejectedCastes = () => async (dispatch) => {
  try {
    const { data } = await api.get("/castes", {
      params: { status: "rejected" },
    });
    dispatch({ type: "REJECTED_CASTES_SUCCESS", payload: data.castes });
  } catch (err) {
    dispatch({
      type: "REJECTED_CASTES_FAIL",
      payload: err.response?.data?.message,
    });
  }
};
